import React, { useEffect, useState } from 'react';
import {
  Button,
  Container,
  Box,
  Modal,
  IconButton,
  Typography,
  Paper,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { jsPDF } from 'jspdf';
import { usePdfSettings } from '../../../layouts/PdfSettingsContext.js';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { SketchPicker } from 'react-color';
import { Close as CloseIcon } from '@mui/icons-material';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
// Static data for 10 students
const mockStudents = [
  {
    studentName: "John Doe",
    studentCode: "ADM001",
    admissionDate: "2023-10-01",
    course: "Computer Science",
    duration: "6 Months",
    batch: "Batch A",
    session: "2024-2025",
    photo: null,
  },
  {
    studentName: "John Doe",
    studentCode: "ADM001",
    admissionDate: "2023-10-01",
    course: "Computer Science",
    duration: "6 Months",
    batch: "Batch A",
    session: "2024-2025",
    photo: null,
  },
  {
    studentName: "John Doe",
    studentCode: "ADM001",
    admissionDate: "2023-10-01",
    course: "Computer Science",
    duration: "6 Months",
    batch: "Batch A",
    session: "2024-2025",
    photo: null,
  },
  {
    studentName: "John Doe",
    studentCode: "ADM001",
    admissionDate: "2023-10-01",
    course: "Computer Science",
    duration: "6 Months",
    batch: "Batch A",
    session: "2024-2025",
    photo: null,
  },
  {
    studentName: "John Doe",
    studentCode: "ADM001",
    admissionDate: "2023-10-01",
    course: "Computer Science",
    duration: "6 Months",
    batch: "Batch A",
    session: "2024-2025",
    photo: null,
  },
  {
    studentName: "John Doe",
    studentCode: "ADM001",
    admissionDate: "2023-10-01",
    course: "Computer Science",
    duration: "6 Months",
    batch: "Batch A",
    session: "2024-2025",
    photo: null,
  },
  {
    studentName: "John Doe",
    studentCode: "ADM001",
    admissionDate: "2023-10-01",
    course: "Computer Science",
    duration: "6 Months",
    batch: "Batch A",
    session: "2024-2025",
    photo: null,
  },
  {
    studentName: "John Doe",
    studentCode: "ADM001",
    admissionDate: "2023-10-01",
    course: "Computer Science",
    duration: "6 Months",
    batch: "Batch A",
    session: "2024-2025",
    photo: null,
  },
  {
    studentName: "John Doe",
    studentCode: "ADM001",
    admissionDate: "2023-10-01",
    course: "Computer Science",
    duration: "6 Months",
    batch: "Batch A",
    session: "2024-2025",
    photo: null,
  },
  {
    studentName: "John Doe",
    studentCode: "ADM001",
    admissionDate: "2023-10-01",
    course: "Computer Science",
    duration: "6 Months",
    batch: "Batch A",
    session: "2024-2025",
    photo: null,
  },
  {
    studentName: "John Doe",
    studentCode: "ADM001",
    admissionDate: "2023-10-01",
    course: "Computer Science",
    duration: "6 Months",
    batch: "Batch A",
    session: "2024-2025",
    photo: null,
  },
  {
    studentName: "John Doe",
    studentCode: "ADM001",
    admissionDate: "2023-10-01",
    course: "Computer Science",
    duration: "6 Months",
    batch: "Batch A",
    session: "2024-2025",
    photo: null,
  },
];

const CustomTableScrollbar = styled('div')(({ theme }) => ({
  overflowY: 'auto',
  backgroundColor: theme.palette.background.paper,
  '&::-webkit-scrollbar': {
    width: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));

const BulkIDCard = () => {
  const theme = useTheme();
  const { pdfThemeColor, pdfTextColor } = usePdfSettings();
  const [openSnackbar, setOpenSnackbar] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');
const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const navigate = useNavigate();
  const staticSessionData = [
    { id: 1, name: '2024-2025' },
    { id: 2, name: '2023-2024' },
    { id: 3, name: '2022-2023' },
  ];
  const staticCourseData = [
    { id: 1, name: 'Computer Science' },
    { id: 2, name: 'Mathematics' },
    { id: 3, name: 'Physics' },
  ];
  const staticBatchData = [
    { id: 1, name: 'Batch A' },
    { id: 2, name: 'Batch B' },
    { id: 3, name: 'Batch C' },
  ];
  const [formData, setFormData] = useState({
    session: '',
    course: '',
    batch: '',
  });
  const [showBulkIDCardModal, setShowBulkIDCardModal] = useState(false);
  const [tempBulkThemeColor, setTempBulkThemeColor] = useState(pdfThemeColor);

  useEffect(() => {
    if (showBulkIDCardModal) {
      setTempBulkThemeColor(pdfThemeColor);
    }
  }, [showBulkIDCardModal, pdfThemeColor]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const generateIDCardPDF = (
    students,
    themeColor = pdfThemeColor,
    textColor = pdfTextColor
  ) => {
    const a4Width = 297;
    const a4Height = 210;
    const cardWidth = 90;
    const cardHeight = 60;
    const cardsPerRow = 3;
    const cardsPerColumn = 3;
    const totalCardWidth = cardsPerRow * cardWidth;
    const totalCardHeight = cardsPerColumn * cardHeight;
    const marginX = (a4Width - totalCardWidth) / (cardsPerRow + 1);
    const marginY = (a4Height - totalCardHeight) / (cardsPerColumn + 1);

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const filteredStudents = students.filter(
      (student) =>
        student.course === formData.course &&
        student.batch === formData.batch
    );

    filteredStudents.forEach((student, index) => {
      const pageIndex = Math.floor(index / 9);
      const cardIndex = index % 9;
      const row = Math.floor(cardIndex / cardsPerRow);
      const col = cardIndex % cardsPerRow;
      const x = marginX + col * (cardWidth + marginX);
      const y = marginY + row * (cardHeight + marginY);

      if (cardIndex === 0 && index !== 0) {
        doc.addPage();
      }

      drawIDCard(
        doc,
        student,
        x,
        y,
        cardWidth,
        cardHeight,
        themeColor,
        textColor
      );
    });

    window.open(doc.output("bloburl"), "_blank");
  };

  const drawIDCard = (
    doc,
    student,
    x,
    y,
    cardWidth,
    cardHeight,
    themeColor,
    textColor
  ) => {
    const hexToRgb = (hex) => {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return [r, g, b];
    };

    const primaryColor = hexToRgb(themeColor);
    const secondaryColor = hexToRgb(themeColor);
    const bodyTextColor = hexToRgb(textColor);
    const accentColor = [220, 53, 69];
    const lightGray = [245, 245, 245];

    doc.setFillColor(...primaryColor);
    doc.rect(x, y, cardWidth, 18, "F");

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    doc.text("INSTITUTE NAME", x + 6, y + 11);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.setTextColor(230, 230, 230);
    doc.text("Kalindi Kunj Rd, Nai Basti, Jamia Nagar", x + 6, y + 15);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    doc.setTextColor(255, 255, 255);
    doc.text("STUDENT ID CARD", x + cardWidth - 6, y + 8, { align: "right" });

    const badgeX = x + cardWidth - 25;
    const badgeY = y + 10;
    doc.setFillColor(255, 255, 255);
    doc.roundedRect(badgeX, badgeY, 20, 6, 1, 1, "F");
    doc.setFontSize(6);
    doc.setTextColor(...primaryColor);
    doc.text(`Batch: ${student.batch}`, badgeX + 10, badgeY + 4, { align: "center" });

    doc.setFillColor(...lightGray);
    doc.rect(x, y + 18, cardWidth, cardHeight - 18, "F");

    const photoX = x + cardWidth - 26;
    const photoY = y + 20;
    const photoWidth = 22;
    const photoHeight = 28;

    doc.setFillColor(200, 200, 200);
    doc.rect(photoX + 0.5, photoY + 0.5, photoWidth, photoHeight, "F");
    doc.setFillColor(255, 255, 255);
    doc.rect(photoX, photoY, photoWidth, photoHeight, "F");
    doc.setDrawColor(180, 180, 180);
    doc.setLineWidth(0.3);
    doc.rect(photoX, photoY, photoWidth, photoHeight, "S");

    if (student.photo) {
      doc.addImage(student.photo, "JPEG", photoX + 1, photoY + 1, photoWidth - 2, photoHeight - 2);
    } else {
      doc.setFillColor(240, 240, 240);
      doc.rect(photoX + 1, photoY + 1, photoWidth - 2, photoHeight - 2, "F");
      doc.setFontSize(8);
      doc.setTextColor(150, 150, 150);
      doc.text("PHOTO", photoX + photoWidth / 2, photoY + photoHeight / 2, { align: "center" });
    }

    doc.setTextColor(...bodyTextColor);
    doc.setFont("helvetica", "normal");

    let currentY = y + 24;
    const leftMargin = x + 6;
    const labelWidth = 25;
    const lineSpacing = 6;

    const addField = (label, value = "", yPos) => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(7);
      doc.setTextColor(...bodyTextColor);
      doc.text(label + ":", leftMargin, yPos);

      doc.setDrawColor(180, 180, 180);
      doc.setLineWidth(0.2);
      const underlineStart = leftMargin + labelWidth;
      const underlineEnd = photoX - 4;
      doc.line(underlineStart, yPos + 1, underlineEnd, yPos + 1);

      if (value) {
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
        doc.setTextColor(...bodyTextColor);
        doc.text(value, underlineStart + 1, yPos);
      }

      return yPos + lineSpacing;
    };

    currentY = addField("Name", student.studentName, currentY);
    currentY = addField("Admission no.", student.studentCode, currentY);
    currentY = addField("Admission Date", student.admissionDate, currentY);
    currentY = addField("Course", student.course, currentY);
    currentY = addField("Duration", student.duration, currentY);

    const footerY = y + cardHeight - 6;

    doc.setFillColor(255, 255, 255);
    doc.rect(x, footerY - 2, cardWidth, 10, "F");

    doc.setDrawColor(...secondaryColor);
    doc.setLineWidth(0.3);
    doc.line(x, footerY - 2, x + cardWidth, footerY - 2);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(6);
    doc.setTextColor(...bodyTextColor);

    doc.text("Student Signature", leftMargin, footerY + 2);
    doc.setDrawColor(150, 150, 150);
    doc.setLineWidth(0.2);
    doc.line(leftMargin + 19, footerY + 2, leftMargin + 38, footerY + 2);

    doc.text("Authorized By", x + cardWidth - 38, footerY + 2);
    doc.line(x + cardWidth - 25 + 2, footerY + 2, x + cardWidth - 6, footerY + 2);

    doc.setDrawColor(...primaryColor);
    doc.setLineWidth(0.5);
    doc.rect(x, y, cardWidth, cardHeight, "S");
  };

  const handleGenerate = () => {
    if (!formData.session || !formData.course || !formData.batch) {
    setSnackbarMessage("Please select Session, Course, and Batch");    
  setOpenSnackbar(true);  
  setSnackbarSeverity("success");
      return;
    }
    const filteredStudents = mockStudents.filter(
      (student) =>
        student.course === formData.course &&
        student.batch === formData.batch &&
        student.session === formData.session
    );
    if (filteredStudents.length === 0) {
      setSnackbarMessage("No admissions match the selected criteria");    
      setOpenSnackbar(true);  
      setSnackbarSeverity("error");
      return;
    }
    setShowBulkIDCardModal(true);
  };

  const handleReset = () => {
    setFormData({
      session: "",
      course: "",
      batch: "",
    });
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth="lg" sx={{ my: 0 }}>
      <Box
        sx={{
          p: 4,
          borderRadius: 2,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <FormControl fullWidth sx={{ mb: 3 }} required>
          <InputLabel sx={{ color: theme.palette.text.primary, "&.Mui-focused": { color: theme.palette.primary.main } }}>
            Session
          </InputLabel>
          <Select
            name="session"
            value={formData.session}
            label="Session"
            onChange={handleChange}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.text.primary,
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.primary.main,
              },
            }}
          >
            {staticSessionData.map((session) => (
              <MenuItem key={session.id} value={session.name}>
                {session.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ mb: 3 }} required>
          <InputLabel sx={{ color: theme.palette.text.primary, "&.Mui-focused": { color: theme.palette.primary.main } }}>
            Course
          </InputLabel>
          <Select
            name="course"
            value={formData.course}
            label="Course"
            onChange={handleChange}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.text.primary,
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.primary.main,
              },
            }}
          >
            {staticCourseData.map((course) => (
              <MenuItem key={course.id} value={course.name}>
                {course.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ mb: 3 }} required>
          <InputLabel sx={{ color: theme.palette.text.primary, "&.Mui-focused": { color: theme.palette.primary.main } }}>
            Batch
          </InputLabel>
          <Select
            name="batch"
            value={formData.batch}
            label="Batch"
            onChange={handleChange}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.text.primary,
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.primary.main,
              },
            }}
          >
            {staticBatchData.map((batch) => (
              <MenuItem key={batch.id} value={batch.name}>
                {batch.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          
          <Button variant="outlined" color="error" onClick={handleReset}>
            Reset
          </Button>
          <Button variant="outlined" color="secondary" onClick={handleBack}>
            Back
          </Button>
          <Button
            variant="contained"
            onClick={handleGenerate}
            sx={{  backgroundColor: theme.palette.primary.main,
              '&:hover': { backgroundColor: theme.palette.primary.dark } }}
          >
            Generate Bulk ID
          </Button>
        </Box>
      </Box>
      <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
     <Modal
  open={showBulkIDCardModal}
  onClose={() => setShowBulkIDCardModal(false)}
  BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 300,
      bgcolor: 'background.paper',
      borderRadius: 2,
      boxShadow: 24,
      p: 3,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2, // adds consistent spacing between elements
    }}
  >
    {/* Header */}
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Typography variant="h6">Select PDF Color</Typography>
      <IconButton onClick={() => setShowBulkIDCardModal(false)} sx={{ p: 0.5 }}>
        <CloseIcon />
      </IconButton>
    </Box>

    {/* Color Picker */}
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Typography>PDF Color:</Typography>
      <SketchPicker
        color={tempBulkThemeColor}
        onChangeComplete={(color) => setTempBulkThemeColor(color.hex)}
      />
    </Box>

    {/* Buttons */}
    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
      <Button
        variant="outlined"
        onClick={() => {
          setTempBulkThemeColor(pdfThemeColor);
        }}
      >
        Reset
      </Button>
      <Button
        variant="contained"
        onClick={() => {
          generateIDCardPDF(mockStudents, tempBulkThemeColor, pdfTextColor);
          setShowBulkIDCardModal(false);
        }}
      >
        Generate Bulk ID Cards
      </Button>
    </Box>
  </Box>
</Modal>

    </Container>
  );
};

export default BulkIDCard;